// Components==============
import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
// =========================

const setActiveDataset = (id: Number) =>
  axios.post(`/api/set-dataset/${id}`).then((r) => r.data);

export default function useSetActiveDataset() {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: setActiveDataset,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["datasets"] });
      queryClient.invalidateQueries({ queryKey: ["categories"] });
    },
    onError: (error) => {
      console.error("Error storing answer", error);
    },
  });

  return mutation;
}
